<template>
  <v-card>
    <v-card-title class="headline">Sign in</v-card-title>

    <div v-if="!state">
      <v-form v-model="valid" ref="form" @submit.prevent="authEmail">
        <v-card-text v-if="!skip">
          Save slides for later.<br>
          Keep track of presentations you've attended.
        </v-card-text>

        <v-card-text v-if="skip">
          Sign in to view this presentation.
        </v-card-text>

        <v-card-text>
          <v-text-field
              filled
              validate-on-blur
              v-model="email"
              :rules="emailRules"
              :messages="fireBaseValidationMessages"
              label="Email address"
              type="email"
          ></v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text v-if="skip" @click="skipLogin">
            Not now
          </v-btn>
          <v-btn text v-if="!skip" @click="closeLoginModal">
            Cancel
          </v-btn>
          <v-btn class="primary" type="submit" dark >
            Sign in
          </v-btn>
        </v-card-actions>
      </v-form>
    </div>

    <div v-if="state === 'emailSend'">
      <v-card-text>
        We have send you an email.<br>
        In there you will find instructions to sign in.
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="primary" dark @click="skipLogin">
          Close
        </v-btn>
      </v-card-actions>
    </div>
  </v-card>
  <!--While waiting for the presentation to start,
  sign in to keep track of your attendance and favorite slides-->
</template>

<script>
import { mapGetters } from 'vuex';
import firebase from 'firebase/app';

export default {
  name: 'login-modal',

  props: [
    'intro',
    'skip',
    'state'
  ],

  data() {
    return {
      valid: true,
      fireBaseValidationMessages: [],
      email: '',
      emailRules: [
        v => !!v || 'Email is required',
        v => /.+@.+/.test(v) || 'Email must be valid'
      ]
    };
  },

  computed: mapGetters([
    'userId',
    'viewedPresentation'
  ]),

  methods: {
    authEmail() {
      if (this.$refs.form.validate()) {
        const email = this.email;
        const presentationParam = this.viewedPresentation.presentationId
          ? `&n=${this.viewedPresentation.presentationId}`
          : '';
        const actionCodeSettings = {
          // url: `https://at-and.com?r=${this.userId}${presentationParam}`,
          url: `${window.location.origin}?r=${this.userId}${presentationParam}`,
          handleCodeInApp: true
        };

        firebase.auth().sendSignInLinkToEmail(email, actionCodeSettings)
          .then(() => {
            this.setState('emailSend');
            window.localStorage.setItem('emailForSignIn', email);
          })
          .catch((error) => {
            this.fireBaseValidationMessages = [error.message];
          });
      }
    },

    setState(step) {
      this.$emit('stateChange', step);
    },

    skipLogin() {
      this.$emit('skipLogin');
    },

    closeLoginModal() {
      this.$emit('loginModalClosed');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/LoginModal.vue